export default function getEndpoint(){
    //return "http://localhost:5194";
    return "https://liudiubackend.azurewebsites.net";
}
